<footer class="main-footer">
    <strong>Copyright &copy; Mount Sinaí Centro Médico.</strong>
    Todos los derechos reservados.
    <div class="float-right d-none d-sm-inline-block">
      <!-- <b>Version</b> 3.0.4 -->
    </div>
</footer>
